import { RichMediaShowType } from '@/const/richMedia';
import { INIT_COORDINATE, INIT_SCALE } from '@/material/form-upload/character/konva';
import { ISpineResult } from '@/material/form-upload/folder';

import { Status } from './aigc';

export enum EAsyncStatus {
  UPLOAD_INIT = 1, // 初始化
  UPLOAD_LOADING = 2, // 上传中
}

export enum ImageDomType {
  NORMAL = 0, // 标准上传样式
  MISSION = 1, // 剧情卡内样式
  REF = 2, // AI生图内添加参考图
}

export interface RichMediaValue {
  id?: string;
  url?: {
    url?: string;
    localPath?: string;
    name?: string
  };
  taskId?: string;
  promptText?: string;
  thumbUrl?: string;
  loopPlay?: boolean;
  autoPlay?: boolean;
  volume?: number;
  width?: number;
  height?: number;
  isPause?: boolean;
  showType?: RichMediaShowType;
  sample?: {
    primary: string, complementary: string;
  },
  fillType?: FillType;
  thumbnail?: string; // 背景视频缩略图

  // 前端使用
  status?: Status;

  // 异步 处理loading
  asyncStatus?: EAsyncStatus;
}

export enum FillType {
  FILL_TYPE_DEFAULT = 0, // 默认裁剪拉伸
  FILL_TYPE_BLANK = 1, // 不拉伸，空白留黑边
}

export interface ThumbnailType {
  url?: string;
  srcType?: 'image' | 'video';
}

// 多人立绘
export interface MultiCharacter {
  id: string,
  image?: RichMediaValue;
  spine?: ISpineResult;
  scale?: number;
  coordinate?: {
    x: number,
    y: number,
  }
}

export const DefaultCharacter: MultiCharacter = {
  id: '',
  scale: INIT_SCALE,
  coordinate: {
    x: INIT_COORDINATE,
    y: INIT_COORDINATE,
  },
};
